<mat-accordion>
  <mat-expansion-panel [expanded]="!groupCollapsed">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ group.display.name }}</mat-panel-title>
      <mat-panel-description class="">
        {{ panelDescription }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">
      <div #fieldContainer>
        <div *ngIf="groupEdition; else groupStatic">
          <mat-form-field
            *ngFor="let attr of attributes"
            [ngSwitch]="attr.type"
            [class]="fieldClass"
          >
            <mat-label>{{
              dictHelper.getAttrNameDisplayWithUnit(attr)
            }}</mat-label>
            <mat-select
              *ngSwitchCase="'ENUM'"
              [formControlName]="attr.code"
              [required]="attr.required"
              placeholder=""
            >
              <mat-option
                *ngFor="let enumValue of attr.availableValues"
                [value]="enumValue.code"
                >{{ enumValue.display.name }}</mat-option
              >
              <mat-option value="NULL">Non défini</mat-option>
            </mat-select>
            <input
              *ngSwitchCase="'DECIMAL'"
              matInput
              placeholder=""
              type=""
              [required]="attr.required"
              [formControlName]="attr.code"
              decimalValue
              [unit]="attr.unit"
            />
            <mat-select
              *ngSwitchCase="'BOOLEAN'"
              [formControlName]="attr.code"
              [required]="attr.required"
              placeholder=""
            >
              <mat-option value="true">Oui</mat-option>
              <mat-option value="false">Non</mat-option>
            </mat-select>
            <input
              *ngSwitchDefault
              matInput
              placeholder=""
              type="text"
              [required]="attr.required"
              [formControlName]="attr.code"
              nullValue
              [unit]="attr.unit"
            />
            <mat-hint *ngIf="attr.display.description" align="end">{{
              attr.display.description
            }}</mat-hint>
            <mat-error>
              <span *ngIf="f(attr.code).hasError('required')"
                >Champs requis</span
              >
            </mat-error>
            <mat-error>
              <span *ngIf="f(attr.code).hasError('pattern')"
                >La valeur doit être de type "{{
                  dictHelper.getAttributeTypeName(attr.type)
                }}"</span
              >
            </mat-error>
            <mat-error>
              <span *ngIf="f(attr.code).hasError('certified')"
                >Un attribut inclu dans la certification ne peut pas être
                supprimé</span
              >
            </mat-error>
            <mat-icon
              *ngIf="attr.summary"
              matSuffix
              class="main-attr"
              color="accent"
              appTooltip="Fait parti des caractéristiques principales"
              >stars</mat-icon
            >
          </mat-form-field>
        </div>

        <ng-template #groupStatic>
          <div
            class="property-field-group"
            *ngIf="hasValueDefined(); else noGroup"
          >
            <ng-container *ngFor="let attr of attributes">
              <div
                [class]="fieldClass + ' property-field-container'"
                *ngIf="values[attr.code] && values[attr.code].value !== ''"
              >
                <div class="property-field">
                  <span
                    class="property-field-title {{
                      attr.summary ? 'summary' : ''
                    }}"
                    >{{ dictHelper.getAttrNameDisplay(attr) }}
                    <mat-icon
                      *ngIf="attr.summary"
                      class="ml-1 align-bottom main-attr"
                      color="accent"
                      appTooltip="Fait parti des caractéristiques principales"
                      >stars</mat-icon
                    ></span
                  >
                  <span
                    [ngClass]="
                      getPropertyFieldValueClass(attr, values[attr.code])
                    "
                    >{{
                      dictHelper.getAttrValueDisplay(
                        attr,
                        values[attr.code].value
                      )
                    }}
                    <mat-icon
                      *ngIf="
                        dictHelper.isAttrUpdateSinceCertif(
                          attr,
                          values[attr.code]
                        )
                      "
                      class="ml-1 align-bottom"
                      color="warn"
                      appTooltip="La valeur a été modifiée depuis la certification. Valeur de certification : {{
                        dictHelper.getAttrValueDisplay(
                          attr,
                          values[attr.code].certificationValue
                        )
                      }}"
                      >info</mat-icon
                    ></span
                  >
                </div>
              </div>
            </ng-container>
          </div>
        </ng-template>
        <ng-template #noGroup>
          <p class="text-center">Aucune valeur n'est configurée</p>
        </ng-template>
        <mat-action-row>
          <div *ngIf="groupEdition; else defaultGroupActions">
            <button
              mat-mini-fab
              color="primary"
              appTooltip="Valider"
              type="submit"
            >
              <mat-icon aria-label="Valider">check</mat-icon>
            </button>
            <button
              mat-mini-fab
              color="primary"
              type="button"
              appTooltip="Annuler"
              (click)="closeEditGroup()"
            >
              <mat-icon aria-label="Annuler">close</mat-icon>
            </button>
          </div>
          <ng-template #defaultGroupActions>
            <div *ngIf="userHelper.canUpdateProperty(prop)" class="mt-2">
              <button
                mat-mini-fab
                color="primary"
                (click)="editGroup()"
                appTooltip="Modifier"
              >
                <mat-icon aria-label="Modifier">create</mat-icon>
              </button>
            </div>
          </ng-template>
        </mat-action-row>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>
